export default "__VITE_ASSET__44efa99f__"